import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ResetPasswordRequest, ResetPasswordResponse, ResetPwdRequest, ResetPwdResponse, CommunicationType, GenerateOtpRequest, GenerateOtpResponse, VerifyOtpRequest, VerifyOtpResponse, EmailMobileUniqueResponse } from "../interfaces/reset-pwd.interface";
@Injectable({
  providedIn: 'root',
})
export class ResetpasswordService {

  constructor(
    private http: HttpClient,
    @Inject('environment') private environment: any
  ) {}

  isEmailMobileUnique(
    communicationType: string,
    receiver: string,
    appName?: string
  ): Observable<EmailMobileUniqueResponse> {
    const postData: any = {appName};
    let subUrl: string = `${this.environment.apiUrl}/password/`;
    if (communicationType === CommunicationType.EMAIL) {
      postData.email = receiver;
      subUrl += 'isEmailExists';
    } else {
      postData.mobile = receiver;
      subUrl += 'isMobileExists';
    }
    return this.http.post<any>(subUrl, postData);
  }

  sendResetPwdLink(data: ResetPwdRequest): Observable<ResetPwdResponse> {
    const url = `${this.environment.apiUrl}/password/sendResetLink`;
    return this.http.post<ResetPwdResponse>(url, data);
  }

  sendResetPassword(
    data: ResetPasswordRequest
  ): Observable<ResetPasswordResponse> {
    const url = `${this.environment.apiUrl}/password/update`;
    return this.http.post<ResetPasswordResponse>(url, data);
  }

  verifyOtp(
    communicationType: string,
    receiver: string,
    otp: string,
    appName?: string
  ): Observable<VerifyOtpResponse> {
    const url = `${this.environment.apiUrl}/password/verify`;
    const data: VerifyOtpRequest = {
      communicationType:
        communicationType === CommunicationType.EMAIL
          ? CommunicationType.EMAIL
          : CommunicationType.MOBILE,
      receiver: receiver,
      verificationType: 'ResetPassword',
      otp: otp,
      appName: appName
    };
    return this.http.post<VerifyOtpResponse>(url, data);
  }
}
